import { SlingConfig } from './sling-config';

export class FrequentDestination {
    id: number;
    name: string;
    slingConfig: SlingConfig;

    constructor() {
        this.slingConfig = new SlingConfig();
    }
}
